module.exports = __webpack_public_path__ + "img/mini-022.297439aa.jpg";